module.exports = __webpack_public_path__ + "img/29.036265c4.jpg";